class CoveHeroVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.toggle = this.querySelector('[data-video-toggle]');

    if (!this.video || !this.toggle) return;

    this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.handleToggle = () => {
      if (this.video.paused) {
        this.video.play().catch(() => this.updateState());
      } else {
        this.video.pause();
      }
    };
    this.updateState = () => {
      const isPaused = this.video.paused;
      this.dataset.paused = String(isPaused);
      this.toggle.setAttribute('aria-label', isPaused ? 'Play Cove video' : 'Pause Cove video');
    };
    this.handleMotionPreference = () => {
      if (this.motionPreference.matches) {
        this.video.removeAttribute('autoplay');
        this.video.pause();
      }
      this.updateState();
    };
    this.handleError = () => this.toggle.setAttribute('hidden', '');

    this.video.controls = false;
    this.toggle.addEventListener('click', this.handleToggle);
    this.video.addEventListener('play', this.updateState);
    this.video.addEventListener('pause', this.updateState);
    this.video.addEventListener('error', this.handleError);
    this.motionPreference.addEventListener?.('change', this.handleMotionPreference);

    this.classList.add('is-ready');
    this.handleMotionPreference();
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.handleToggle);
    this.video?.removeEventListener('play', this.updateState);
    this.video?.removeEventListener('pause', this.updateState);
    this.video?.removeEventListener('error', this.handleError);
    this.motionPreference?.removeEventListener?.('change', this.handleMotionPreference);
  }
}

if (!customElements.get('cove-hero-video')) {
  customElements.define('cove-hero-video', CoveHeroVideo);
}
